import api from "@/services/api.service";

export default {
 name: 'response-contact',
 components: {},
 props: {
  caption: {
    type: String,
    default: "Direct Mass Imported Contact List"
  },
  hover: {
    type: Boolean,
    default: true
  },
  striped: {
    type: Boolean,
    default: true
  },
  bordered: {
    type: Boolean,
    default: false
  },
  small: {
    type: Boolean,
    default: false
  },
  fixed: {
    type: Boolean,
    default: false
  }
},
data() {
  return {
    icon: 'fa fa-sort',
    selcol: '',
    items: [],
    fields: [
    { key: "#" },
    { key: "actions", stickyColumn: true },
    // { key: "status", sortable:true }
    ],
    sech: {},
    colName : '',
    currentSortDir:'desc',        
    currentPage: 1,
    perPage: 10,
    totalRows: null,
    totalResponseContact: null,
    isBusy: true,
    delete_ids: [],
    allSelected: false,
    conflict_cnt:'',
    permission_importedList: false,
    permission_deleteImportedContact: false,
    superAdmin:false
  };
},
computed: {},
mounted() {},
created() {
  this.getDirectImportedContacts();
  this.getUserPermissions();
},
watch: {
  currentPage: {
    handler: function(page) {         
        // this.getDirectImportedContacts(page)
        this.toSort(this.colName,page); 
    }
  }
},
methods: {
  makeToast(message = "", title = "Alert", variant = "warning") {
    this.toastCount++;
    this.$root.$bvToast.toast(message, {
      title: title,
      variant: variant,
      autoHideDelay: 3000
    });
  },
  selectAll: function(e) {
    this.delete_ids = [];            
    if(e.target.checked){
      for (var item in this.items) {
        this.delete_ids.push(this.items[item].id.toString());
      }                
    }            
  },
  selectOne(){
    this.allSelected = false;            
  },
  async getUserPermissions() {
    let response = await api.post("users/user-permissions");
          const permissions = [];
          if (response.status == "success") {
            response.data[0].permission.forEach( function(element) {                
                permissions.push(element.action)
            }.bind(this));
              if(permissions.includes("list_direct_imported_contact") == true){
                this.permission_importedList = permissions.includes("list_direct_imported_contact");
                this.permission_deleteImportedContact = permissions.includes("delete_direct_imported_contact");
              }else if(response.data[0].role == 'super_admin'){
                this.superAdmin = true;
              }else if(permissions.includes("list_direct_import_contact") == true || permissions.includes("add_direct_import_contact") == true){
                  this.makeToast("Permission denied","Alert","warning",6000);
                  this.$router.push({name: 'Direct Mass Import List'});
              }else{
                  this.makeToast("Permission denied","Alert","warning",6000);
                  this.$router.push({name: 'Admin Dashboard'});
              }
          }  
  },
  async getDirectImportedContacts(page) {
    this.items = [];
    this.sech.page = page;
    this.sech.import_contact_id = this.$route.params.id;
    this.isBusy=true;
    let response = await api.post("admin/direct-mass-import/direct-imported-contact-list", this.sech);          
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.records.data != "") {  
        //GET ALL HEADERS FROM JSON     
        // var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.records.data[0].contact_data)]));
        var columns = response.data.header;    
        columns.splice(0,0);
        columns.map((h) => {
         this.fields.push({key: h, sortable: false}) 
       });

        //Iterate Data 
        response.data.records.data.forEach( function(element) {                    
          var someObject = Object.assign({}, JSON.parse(element.contact_data), {id:element.id,status:element.status} )
          this.items.push(someObject);  
        }.bind(this));
      
        this.totalResponseContact = response.data.records.total;        
        this.currentPage = response.data.records.current_page;
        this.perPage = response.data.records.per_page;
        this.pageOptions.forEach(element => {
          if(element.value > this.totalResponseContact){
              var indexOf = this.pageOptions.indexOf(element);
              if( indexOf != 0 )
              this.pageOptions.splice(indexOf)
          }
        });
        if(this.totalResponseContact <= 500)
        this.pageOptions.push({text:'All',value:this.totalResponseContact});
      } else {
        this.items = [];
      }
    }      
    this.isBusy = false;
  },
  async toSort(items,page = 1) {
    if (items != "actions" && items != "#") {    
      this.items = [];

      if(page == 1)
      if(items == this.colName)
      this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
  
      this.colName = items;
      this.sech.page = page;
      this.sech.import_contact_id = this.$route.params.id;
      this.isBusy=true;
      let response = await api.post("admin/direct-mass-import/direct-imported-contact-list", { page:page,columnname:items,sortType:this.currentSortDir,import_contact_id:this.sech.import_contact_id,paginateVal:this.perPage });
      if (!response)
        this.makeToast("Something went to wrong please try again","Alert","danger",6000);
      if (response.status == "success") {
       if (response.data.records.data != "") {  
         if(this.currentSortDir == 'asc'){
          this.icon1 = 'fa fa-sort-up';                             
          this.selcol = items;        
         } else{ 
          this.icon1 = 'fa fa-sort-down';                             
          this.selcol = items;
         } 
        //GET ALL HEADERS FROM JSON     
        // var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.records.data[0].contact_data)]));
        var columns = response.data.header;    
        columns.splice(0,0);
        columns.map((h) => {
         this.fields.push({key: h, sortable: false}) 
        });

        //Iterate Data 
        response.data.records.data.forEach( function(element) {                    
          var someObject = Object.assign({}, JSON.parse(element.contact_data), {id:element.id,status:element.status} )
          this.items.push(someObject);  
        }.bind(this));

               
        this.totalResponseContact = response.data.records.total;        
        this.currentPage = response.data.records.current_page;
        this.perPage = response.data.records.per_page;
       } else {
         this.items = [];
       }
      }      
      this.isBusy = false;     
     }
  },
  getRowCount(items) {    
    return items.length;
  },
  multipleDelete(){
    this.$bvModal
    .msgBoxConfirm("Are you sure want to delete this DirectImported Event response Contacts?")
    .then(value => {
      if (value) {
        this.deleteDirectImportedContact(this.delete_ids, 0);
      } else {
        return;
      }
    })
    .catch(function() {
      return;
    });
  },singleDelete(id, index) {
    this.$bvModal
    .msgBoxConfirm("Are you sure want to delete this direct imported response contact?")
    .then(value => {
      if (value) {
        this.deleteDirectImportedContact(id, index);
      } else {
        return;
      }
    })
    .catch(function() {
      return;
    });
  },
  async deleteDirectImportedContact(id, index) {

    let response = await api.post("admin/direct-mass-import/delete-direct-imported-contact",
      { id: id , import_contact_id : this.$route.params.id });

    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);

    if (response.status == "success") {

      if(index == 0){
        this.items = [];
        this.getDirectImportedContacts();
      }
      else
        this.items.splice(index, 1);

      this.makeToast(response.message || `Direct imported delete successful.`,"Alert","success");
    } 
    else 
      this.makeToast(`Direct Imported not deleted.`, "Alert", "danger");
  },
}
};
